import log, { LogLevelDesc } from 'loglevel';
import { LocalStorageManager } from '../browser-utilities/local-storage-manager';

const LOGLEVEL_LOCAL_STORAGE_KEY = 'ce.loglevel';

/**
 * Loads the persisted log level from the local storage and applies it.
 * This replaces the default loglevel storage key of the `loglevel` package.
 */
export function loadPersistedLogLevel() {
  const storedLogLevel = LocalStorageManager.getItem(LOGLEVEL_LOCAL_STORAGE_KEY);
  if (storedLogLevel) {
    log.setLevel(storedLogLevel as LogLevelDesc, false);
  }
}

/**
 * Sets the current log level and persists it to the local storage.
 * @param level - LogLevelDesc
 */
export function setLogLevel(level: LogLevelDesc) {
  log.setLevel(level, false);
  LocalStorageManager.setItem(LOGLEVEL_LOCAL_STORAGE_KEY, level.toString());
}

/**
 * While the default loglevel is `warn`, this will set it to `silent` if true, disabling any custom log output or back to default `warn` if false.
 * @param value - boolean
 */
export function setDefaultLogLevelToSilent(value: boolean): void {
  if (!LocalStorageManager.getItem(LOGLEVEL_LOCAL_STORAGE_KEY)) {
    log.setDefaultLevel(value ? 'silent' : 'warn');
  }
}